"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shadow = void 0;
require("@tiptap/extension-text-style");
const core_1 = require("@tiptap/core");
exports.Shadow = core_1.Extension.create({
    name: 'shadow',
    addOptions() {
        return {
            types: ['textStyle'],
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    shadow: {
                        default: null,
                        parseHTML: (element) => element.style.textShadow?.replace(/['"]+/g, ''),
                        renderHTML: (attributes) => {
                            if (!attributes.shadow || attributes.shadow === 'NONE') {
                                return {};
                            }
                            return {
                                class: getShadowClass(attributes.shadow),
                            };
                        },
                    },
                },
            },
        ];
    },
    addCommands() {
        return {
            setShadow: (shadow) => ({ chain }) => {
                return chain().setMark('textStyle', { shadow }).run();
            },
            unsetShadow: () => ({ chain }) => {
                return chain().setMark('textStyle', { shadow: null }).removeEmptyTextStyle().run();
            },
        };
    },
});
function getShadowClass(shadowValue) {
    switch (shadowValue) {
        case 'HARD':
            return 'shadow-hard';
        case 'MEDIUM':
            return 'shadow-medium';
        case 'SOFT':
            return 'shadow-soft';
        default:
            return '';
    }
}
//# sourceMappingURL=shadow.js.map